/*
 * Copyright (C) 2020 DV Bern AG, Switzerland
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */

import {TSAbstractEntity} from '../entity/TSAbstractEntity';
import {TSInstitution} from '../entity/TSInstitution';
import {TSLastenausgleichTagesschuleAngabenInstitutionStatus} from '../enums/TSLastenausgleichTagesschuleAngabenInstitutionStatus';
import {TSLastenausgleichTagesschuleAngabenInstitution} from './TSLastenausgleichTagesschuleAngabenInstitution';

export class TSLastenausgleichTagesschuleAngabenInstitutionContainer extends TSAbstractEntity {
    public status: TSLastenausgleichTagesschuleAngabenInstitutionStatus;
    public institution: TSInstitution;
    public angabenDeklaration: TSLastenausgleichTagesschuleAngabenInstitution;
    public angabenKorrektur: TSLastenausgleichTagesschuleAngabenInstitution;

    public isAtLeastInBearbeitungGemeinde(): boolean {
        return [
            TSLastenausgleichTagesschuleAngabenInstitutionStatus.IN_PRUEFUNG_GEMEINDE,
            TSLastenausgleichTagesschuleAngabenInstitutionStatus.GEPRUEFT
        ].includes(this.status);
    }

    public isInBearbeitungInstitution(): boolean {
        return [
            TSLastenausgleichTagesschuleAngabenInstitutionStatus.OFFEN
        ].includes(this.status);
    }

    public isInPruefungGemeinde(): boolean {
        return (
            this.status ===
            TSLastenausgleichTagesschuleAngabenInstitutionStatus.IN_PRUEFUNG_GEMEINDE
        );
    }

    public isGeprueftGemeinde(): boolean {
        return (
            this.status ===
            TSLastenausgleichTagesschuleAngabenInstitutionStatus.GEPRUEFT
        );
    }
}
